import type { DefaultError } from "@tanstack/query-core";
import type { UseMutationOptions } from "@tanstack/react-query";

export const mergeMutationOptions = <
	TData = unknown,
	TError = DefaultError,
	TVariables = void,
	TContext = unknown,
>(
	options1: UseMutationOptions<TData, TError, TVariables, TContext>,
	options2: UseMutationOptions<TData, TError, TVariables, TContext>,
): UseMutationOptions<TData, TError, TVariables, TContext> => {
	return {
		...options1,
		...options2,
		onSuccess: (data, variables, context) => {
			options1.onSuccess?.(data, variables, context);
			options2.onSuccess?.(data, variables, context);
		},
		onError: (error, variables, context) => {
			options1.onError?.(error, variables, context);
			options2.onError?.(error, variables, context);
		},
		onSettled: (data, error, variables, context) => {
			options1.onSettled?.(data, error, variables, context);
			options2.onSettled?.(data, error, variables, context);
		},
		onMutate: (variables) => {
			let ctx: TContext | undefined = undefined;
			if (options1.onMutate) {
				const options1Ctx = options1.onMutate(variables);
				if (options1Ctx) {
					ctx = {
						...((ctx || {}) as TContext),
						...options1Ctx,
					};
				}
			}
			if (options2.onMutate) {
				const options2Ctx = options2.onMutate(variables);
				if (options2Ctx) {
					ctx = {
						...((ctx || {}) as TContext),
						...options2Ctx,
					};
				}
			}
			return ctx;
		},
	};
};
